<template>
  <div id="fee">
    <component
      :is="isComponent"
      :type="type"
      :isHome="isHome"
      :payWayCode="payWayCode"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TwoCryptoBuy from "@/components/IncludedDetails/Buy/TwoCryptoBuy/index.vue";
import IncludedDetails from "@/components/IncludedDetails/Buy/Default/index.vue";
import { hashQuery } from "@/utils/publicRequest";
export default {
  name: "IncludedDetailsBuy",
  props: {
    type: {
      type: Number,
      default: 2,
    },
    //是否在首页
    isHome: {
      type: Boolean,
      default: null,
    },
    //确认订单页支付方式code
    payWayCode: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("buyCryptoMerchant", {
      merchantInfo: (state) => state.merchantInfo,
    }),
    ...mapState("buyCryptoMerchantTwoCrypto", {
      cryptoInfoTwo: (state) => state.cryptoInfoTwo,
    }),
    isComponent() {
      let { merchantType, merchantStatus, merchantQueryInfo } =
        this.merchantInfo;
      let { cryptoSlave } = hashQuery().query;
      if (
        cryptoSlave ||
        (merchantStatus &&
          merchantType === "page" &&
          merchantQueryInfo.cryptoSlave)
      ) {
        return TwoCryptoBuy;
      }
      return IncludedDetails;
    },
  },
  data() {
    return {
      timeOut: null,
      timeDownNumber: 15,
    };
  },
  destroyed() {
    this.timeDownNumber = 15;
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
  deactivated() {
    this.timeDownNumber = 15;
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
};
</script>

<style scoped lang="scss"></style>
